import { getTestIds } from '../../utils/TestIds';
export const importLottiePlayerInner = ()=>import('./LottiePlayerInner').then((module)=>({
            default: module.LottiePlayerInner
        }));
export const prefetchLottie = ()=>{
    void importLottiePlayerInner();
};
export const GetLottiePlayerTID = (parentTestId)=>getTestIds(parentTestId);
